import { ReactComponent as BookmarksIcon } from "../assets/icons/chats/BookmarksOutline.svg";
import genIcons from "./genIcons";

const Bookmarks = { Outline: genIcons(BookmarksIcon, { htmlColor: "transparent" }) };

export default Bookmarks;
